import React from 'react';
import { useTranslation } from 'react-i18next';
import usePresenceStatus from '../../hooks/usePresenceStatus';
import PresenceBadge from './PresenceBadge';

/**
 * The connected one-liner for call sites: drop it inside a `<UserAvatar>` and
 * the badge appears when — and only when — there is something honest to show.
 *
 * Opt-in per call site on purpose, not automatic on every avatar: the bottom
 * right corner is already the unread badge on the chat sidebar rows, and a
 * status dot on an 18px mention chip is noise rather than information.
 */
export default function AvatarStatusBadge({ userId, avatarSize, className }) {
  const { t } = useTranslation();
  const status = usePresenceStatus(userId);
  if (!status) return null;

  return (
    <PresenceBadge
      status={status}
      avatarSize={avatarSize}
      label={t(`presence.${status}`)}
      className={className}
    />
  );
}
